import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'

import type { ProductStatusType } from '@/api/admin-products-types'
import type { PricingMethodType } from '@/api/common-types'
import { preloadListProducts } from '@/api/react-query'

const ProductsSearchSchema = z.object({
	limit: z.coerce.number().default(30),
	offset: z.coerce.number().default(0),
	q: z.string().optional(),
	sortBy: z.enum(['title', 'status']).optional(),
	sortOrder: z.enum(['asc', 'desc']).optional(),
	salesChannels: z.array(z.string()).optional(),
	status: z.array(z.string()).optional(),
	pricingMethod: z.array(z.string()).optional()
})

export const Route = createFileRoute('/_authenticated/_general/products')({
	validateSearch: ProductsSearchSchema,
	loaderDeps: ({ search: { limit, offset, q, sortBy, sortOrder, salesChannels, status, pricingMethod } }) => ({
		limit,
		offset,
		q,
		sortBy,
		sortOrder,
		salesChannels,
		status,
		pricingMethod
	}),
	loader: async ({ context, deps: { limit, offset, q, sortBy, sortOrder, salesChannels, status, pricingMethod } }) =>
		await preloadListProducts(context, {
			query: {
				limit,
				offset,
				q,
				sortBy,
				sortOrder,
				salesChannels: salesChannels?.length ? salesChannels : undefined,
				status: (status?.length ? status : undefined) as ProductStatusType[] | undefined,
				pricingMethod: (pricingMethod?.length ? pricingMethod : undefined) as PricingMethodType[] | undefined
			}
		}),
	staticData: {
		crumb: ({ context: { L } }) => L.Products.Title()
	}
})
